import React from "react";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { X as CloseIcon } from "lucide-react";
import {
  UserExerciseDto,
  BodypartType,
} from "@growth-machine-llc/stridist-api-client";
import makeStyles from "@mui/styles/makeStyles";
import ExerciseList from "./ExerciseList";
import BodypartBars from "./BodypartBars";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  tooltipContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    width: "auto",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1.25),
    maxWidth: "max-content",
  },
}));

interface Props {
  dayItem: any;
  selectedBodypart: BodypartType;
  formattedDate: string;
  onExerciseSelect?: (exercise: UserExerciseDto) => void;
  onShowMore?: () => void;
  onClose?: () => void;
  className?: string;
  exerciseListInitialExpanded?: boolean;
  isTooltip?: boolean;
}

const CalendarDayInfo: React.FC<Props> = ({
  dayItem,
  selectedBodypart,
  formattedDate,
  onExerciseSelect,
  onShowMore,
  onClose,
  className,
  exerciseListInitialExpanded,
  isTooltip = false,
}) => {
  const s = useStyles();
  const { assets, bodyparts } = dayItem;

  return (
    <Box className={clsx(className, s.tooltipContent)}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontSize={14} fontWeight={500}>
          {formattedDate}
        </Typography>
        {onClose && (
          <IconButton onClick={onClose}>
            <CloseIcon size={24} />
          </IconButton>
        )}
      </Box>

      {assets?.length === 0 ? (
        <Typography>No completed exercises for this day.</Typography>
      ) : (
        <>
          <ExerciseList
            assets={assets}
            onExerciseSelect={onExerciseSelect}
            onShowMore={onShowMore}
            initialExpanded={exerciseListInitialExpanded}
          />
          <BodypartBars
            bodyparts={bodyparts}
            isTooltip={isTooltip}
            selectedBodypart={selectedBodypart}
          />
        </>
      )}
    </Box>
  );
};

export default CalendarDayInfo;
